import { EquipmentStatusCategoryOptions } from '@models/EquipmentStatus.model';

import { CustomOption, Circle } from './StatusBadge.styles';

interface IStatusBadge {
  label: EquipmentStatusCategoryOptions;
  name?: string;
  fontColor?: string;
}

export const StatusBadge = ({ label, name, fontColor }: IStatusBadge) => {
  return (
    <CustomOption fontColor={fontColor}>
      <Circle category={label} />
      {name || label}
    </CustomOption>
  );
};
